import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import JSZip from "jszip";

function GeoTagView() {
  const [searchParams] = useSearchParams();
  const RequestId = searchParams.get("id");
  const [geodata, setRequestData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showNearbyUsersModal, setShowNearbyUsersModal] = useState(false); // New state for nearby users modal
  const [nearbyUsers, setNearbyUsers] = useState([]); // State for nearby users data
  const [nearbyUsersLoading, setNearbyUsersLoading] = useState(false); // Loading state for nearby users
  const [isLoading, setIsLoading] = useState(false);
  const [userFilterForm, setUserFilterForm] = useState({
    range: 2000 // Default range in meters
  });

  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [notificationForm, setNotificationForm] = useState({
    title: "",
    body: "",
    range: 2000,
    countryCode: "+91",
    notification_type: "Geotags",
    notification_ref: "",
    useOneSignal: false,
    image_url: "",
    additionalData: {
      type: "open_screen",
      screen: "geotag_deals"
    }
  });

  useEffect(() => {
    if (RequestId) {
      fetchData(RequestId);
    }
  }, [RequestId]);

  const fetchData = async (RequestId) => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "geoTagInfo",
          module: "geotag",
          geoTagId: RequestId,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        setRequestData(data.result.geoTagInfo[0] || null);
      } else {
        console.error("Failed to fetch geotags:", data);
        setRequestData(null);
        setErrorMessage("Failed to load data.");
      }
    } catch (error) {
      console.error("Error fetching geotag data:", error);
      setRequestData(null);
      setErrorMessage("Error fetching geotag data.");
    }
  };

  // New function to fetch nearby users
  const fetchNearbyUsers = async () => {
    setNearbyUsersLoading(true);
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "getNearbyUsers",
          module: "geotag",
          treasure_id: RequestId,
          range: userFilterForm.range,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        setNearbyUsers(data.result);
        setShowNearbyUsersModal(true);
      } else {
        alert("Failed to fetch nearby users: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error fetching nearby users:", error);
      alert("Error fetching nearby users. Please try again.");
    } finally {
      setNearbyUsersLoading(false);
    }
  };

  const uploadImageToS3 = async (file) => {
    setUploadProgress(0);
    setIsUploadingImage(true);

    try {
      // Request presigned URL from backend
      const presignedUrlResponse = await axios.post(process.env.REACT_APP_APIURL, {
        environment: "live",
        apikey: process.env.REACT_APP_APIKEY,
        secret: process.env.REACT_APP_SECRET,
        method: "getS3presignedUrls",
        module: "notification",
        fileName: file.name,
        fileType: file.type,
        userId:"67f3a8ed25dae0d49427de6c"
      });

      const data = presignedUrlResponse.data;
      if (data.statusCode !== 200) {
        throw new Error("Failed to get presigned URL");
      }

      const { url, fields, key, file_id } = data.result;

      // Create FormData for S3 upload
      const formData = new FormData();

      // Add key first
      formData.append('key', key);

      // Add all other fields from the presigned URL response
      if (fields) {
        Object.keys(fields).forEach(fieldKey => {
          if (fieldKey !== 'key') {
            formData.append(fieldKey, fields[fieldKey]);
          }
        });
      }

      // Append the file AFTER other required fields
      formData.append('file', file);

      // Upload to S3 with progress tracking
      const uploadResponse = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = (progressEvent.loaded / progressEvent.total);
          setUploadProgress(percentCompleted);
        }
      });

      // Construct file URL
      const fileUrl = `${url}/${key}`;

      return {
        file_url: fileUrl,
        file_id: file_id
      };

    } catch (error) {
      console.error('Image upload error:', error);
      alert('Failed to upload image. Please try again.');
      throw error;
    } finally {
      setIsUploadingImage(false);
      setUploadProgress(0);
    }
  };
  const handleImageSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size should be less than 5MB');
      return;
    }

    try {
      const uploadResult = await uploadImageToS3(file);
      setNotificationForm(prev => ({
        ...prev,
        image_url: uploadResult.file_url
      }));
      alert('Image uploaded successfully!');
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };
  const handleRemoveImage = () => {
    setNotificationForm(prev => ({
      ...prev,
      image_url: ""
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "additionalData.type" || name === "additionalData.screen") {
      const field = name.split('.')[1];
      setNotificationForm(prev => ({
        ...prev,
        additionalData: {
          ...prev.additionalData,
          [field]: value
        }
      }));
    } else {
      setNotificationForm(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleUserFilterChange = (e) => {
    const { name, value } = e.target;
    setUserFilterForm(prev => ({
      ...prev,
      [name]: parseInt(value) || 0
    }));
  };

  const handleSendNotification = async () => {
    setIsLoading(true);
    try {
      const payload = {
        ...notificationForm,
        treasureId: RequestId,
      };

      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "sendBusinessTreasureNotifications",
          module: "notification",
          ...payload,
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        alert("Notification sent successfully!");
        setShowModal(false);
        setNotificationForm({
          title: "",
          body: "",
          range: 2000,
          countryCode: "+91",
          notification_type: "Geotags",
          notification_ref: "Geotag_notification",
          useOneSignal: true,
          image_url: "",
          additionalData: {
            type: "open_screen",
            screen: "geotag_deals"
          }
        });
      } else {
        alert("Failed to send notification: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      alert("Notification sent successfully!");
      setShowModal(false);
      setNotificationForm({
        title: "",
        body: "",
        range: 2000,
        countryCode: "+91",
        notification_type: "Geotags",
        notification_ref: "Geotag_notification",
        image_url: "",
        useOneSignal: true,
        additionalData: {
          type: "open_screen",
          screen: "geotag_deals"
        }
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (!geodata) {
    return <div>{errorMessage || "Loading..."}</div>;
  }

  const formatFileName = (fileName) => {
    const extension = fileName.split(".").pop();
    let baseName = fileName;

    if (fileName.length > 10) {
      baseName = fileName.substring(0, 6);
      return `${baseName}...${extension}`;
    } else {
      return fileName;
    }
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('User ID copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };
  const exportUserIdsToCSV = () => {
    if (!nearbyUsers.users || nearbyUsers.users.length === 0) {
      alert('No users to export');
      return;
    }

    // Create CSV content with OneSignal bulk notification format
    const csvHeader = 'user_id,title,body,treasureId,geotags_data,geotagtype\n';

    const csvContent = nearbyUsers.users.map(user => {
      // Create geotags_data object
      const geotagsData = JSON.stringify([{
        geotagId: RequestId,
        location: {
          type: "Point",
          coordinates: [geodata.longitude, geodata.latitude]
        }
      }]);

      // Escape double quotes in JSON string for CSV
      const escapedGeotagsData = geotagsData.replace(/"/g, '""');

      return `${user.userId},"title","message",${RequestId},"${escapedGeotagsData}",${geodata.geotag_type || 'Business'}`;
    }).join('\n');

    const csvData = csvHeader + csvContent;

    // Create and download the file
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `onesignal_bulk_notification_${RequestId}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  {geodata.user?.countryCode} {geodata.user?.mobile}
                </h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <button
                      className="btn btn-success mr-3"
                      onClick={fetchNearbyUsers}
                      disabled={nearbyUsersLoading}
                    >
                      {nearbyUsersLoading ? (
                        <>
                          <i className="fa fa-spinner fa-spin mr-2"></i>
                          Loading...
                        </>
                      ) : (
                        <>
                          <i className="fa-solid fa-users mr-2" />
                          Find Nearby Users
                        </>
                      )}
                    </button>
                  </li>
                  <li className="breadcrumb-item">
                    <button
                      className="btn btn-primary mr-3"
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa-solid fa-bell mr-2" />
                      Send Notification
                    </button>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/geotags">
                      <i className="fa-solid fa-arrow-left-long mr-2" />
                      Back
                    </a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <div className="card-body">
                    {/* Range Filter Input */}
                    <div className="row mb-3">
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-form-label">
                            Search Range (meters)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="range"
                            value={userFilterForm.range}
                            onChange={handleUserFilterChange}
                            min="100"
                            max="50000"
                            placeholder="Enter range in meters"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Business
                          </label>
                          <div className="col-12 col-md-8">
                            {geodata.business?.name || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            GeoTag Place
                          </label>
                          <div className="col-12 col-md-8">
                            <a
                              href={`https://www.google.com/maps?q=${geodata.latitude},${geodata.longitude}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {geodata.geoTagPlace || "N/A"}
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Latitude
                          </label>
                          <div className="col-12 col-md-8">
                            {geodata.latitude || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">
                            Longitude
                          </label>
                          <div className="col-12 col-md-8">
                            {geodata.longitude || "N/A"}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                        <div className="form-group">
                          <label className="col-12 col-form-label">Text</label>
                          <div className="col-12 col-md-8">
                            {geodata.text || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="f_sz16 fwt_600">
                          Hunted ({geodata.viewedUsers.length}){" "}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      {geodata.viewedUsers?.map((user) => (
                        <div
                          key={user.userId}
                          className="col-6 col-sm-3 col-md-3 col-lg-2"
                        >
                          <div className="mt-3">
                            <label className="col-12 col-form-label">
                              {user.countryCode}
                              {user.mobile}
                            </label>
                            <div className="col-12 col-md-8">
                              {user.nickName}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="row mt-3">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="f_sz16 fwt_600">
                          Opened ({geodata.openedUsers.length}){" "}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      {geodata.openedUsers?.map((user) => (
                        <div
                          key={user.userId}
                          className="col-6 col-sm-3 col-md-3 col-lg-2"
                        >
                          <div className="mt-3">
                            <label className="col-12 col-form-label">
                              {user.countryCode}
                              {user.mobile}
                            </label>
                            <div className="col-12 col-md-8">
                              {user.nickName}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="row mt-3">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="f_sz16 fwt_600">
                          Files ({geodata.files.length}){" "}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-3">
                      {geodata.files.map((file) => {
                        return (
                          <div
                            key={file.fileURL}
                            className="col-6 col-sm-3 col-md-3 col-lg-2"
                          >
                            <div className="store_imgdiv mt-3">
                              <div className="storeimg">
                                {file.fileType === "audio" ? (
                                  <audio controls>
                                    <source
                                      src={file.fileURL}
                                      type={`audio/${file.fileURL
                                        .split(".")
                                        .pop()
                                        .toLowerCase()}`}
                                    />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                ) : file.fileType === "video" ? (
                                  <div className="videoWrapper">
                                    <video controls>
                                      <source
                                        src={file.fileURL}
                                        type={`video/mp4`}
                                      />
                                      Your browser does not support the video
                                      element.
                                    </video>
                                  </div>
                                ) : file.fileType === "image" ? (
                                  <img
                                    src={file.fileURL}
                                    alt="file"
                                    border={0}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Nearby Users Modal */}
      {showNearbyUsersModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  Nearby Users - {nearbyUsers.totalUsers} users found within {nearbyUsers.searchRange}m
                </h4>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowNearbyUsersModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {nearbyUsers.users && nearbyUsers.users.length > 0 ? (
                  <div className="row">
                    {nearbyUsers.users.map((user, index) => (
                      <div key={user.userId} className="col-12 col-md-6 col-lg-4 mb-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex align-items-center mb-2">
                              {user.profileImage && (
                                <img
                                  src={user.profileImage}
                                  alt="Profile"
                                  className="rounded-circle mr-2"
                                  style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                />
                              )}
                              <div className="flex-grow-1">
                                <h6 className="card-title mb-0">
                                  {user.nickName}
                                </h6>
                                <small className="text-muted">
                                  {user.countryCode} {user.mobile}
                                </small>
                              </div>
                            </div>

                            {/* User ID Section with Copy Icon */}
                            <div className="row mb-2">
                              <div className="col-12">
                                <small className="text-muted">User ID:</small>
                                <div className="d-flex align-items-center">
                                  <span className="font-weight-bold mr-2" style={{ fontSize: '12px' }}>
                                    {user.userId}
                                  </span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary p-1"
                                    onClick={() => copyToClipboard(user.userId)}
                                    title="Copy User ID"
                                    style={{ fontSize: '10px', lineHeight: '1' }}
                                  >
                                    <i className="fa fa-copy"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-6">
                                <small className="text-muted">Distance:</small>
                                <div className="font-weight-bold">
                                  {user.distanceFromTreasure}m
                                </div>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">Status:</small>
                                <div className="font-weight-bold">
                                  <span className={`badge ${user.paidStatus === 'PREMIUM' ? 'badge-success' : 'badge-secondary'}`}>
                                    {user.paidStatus}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-6">
                                <small className="text-muted">Reward Points:</small>
                                <div className="font-weight-bold">
                                  {user.rewardPoints || 0}
                                </div>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">Location:</small>
                                <div>
                                  <a
                                    href={`https://www.google.com/maps?q=${user.latitude},${user.longitude}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-primary"
                                  >
                                    <i className="fa fa-map-marker-alt mr-1"></i>
                                    View
                                  </a>
                                </div>
                              </div>
                            </div>
                            {user.lastActivityAt && (
                              <div className="mt-2">
                                <small className="text-muted">
                                  Last Activity: {new Date(user.lastActivityAt).toLocaleDateString()}
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <i className="fa fa-users fa-3x text-muted mb-3"></i>
                    <h5>No users found</h5>
                    <p className="text-muted">
                      No users found within {nearbyUsers.searchRange}m of this treasure location.
                    </p>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowNearbyUsersModal(false)}
                >
                  Close
                </button>
                {nearbyUsers.users && nearbyUsers.users.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={exportUserIdsToCSV}
                  >
                    <i className="fa fa-download mr-2"></i>
                    Export Data
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Send Notification Modal */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Send Notification</h4>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Title *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={notificationForm.title}
                        onChange={handleInputChange}
                        placeholder="Enter notification title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Country Code *</label>
                      <select
                        className="form-control"
                        name="countryCode"
                        value={notificationForm.countryCode}
                        onChange={handleInputChange}
                      >
                        <option value="+91">+91 (India)</option>
                        <option value="+1">+1 (USA)</option>
                        <option value="+44">+44 (UK)</option>
                        <option value="+971">+971 (UAE)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Message Body *</label>
                      <textarea
                        className="form-control"
                        name="body"
                        value={notificationForm.body}
                        onChange={handleInputChange}
                        placeholder="Enter notification message"
                        rows={3}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Range (meters) *</label>
                      <input
                        type="number"
                        className="form-control"
                        name="range"
                        value={notificationForm.range}
                        onChange={handleInputChange}
                        placeholder="Enter range in meters"
                        min="100"
                        max="50000"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Notification Type *</label>
                      <select
                        className="form-control"
                        name="notification_type"
                        value={notificationForm.notification_type}
                        onChange={handleInputChange}
                      >
                        <option value="Geotags">Geotags</option>
                        <option value="Business">generic_notification</option>
                        <option value="Treasure">circle_create</option>
                        <option value="General">General</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Notification Reference *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="notification_ref"
                        value={notificationForm.notification_ref}
                        onChange={handleInputChange}
                        placeholder="Enter notification reference"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="useOneSignal"
                        checked={notificationForm.useOneSignal}
                        onChange={handleInputChange}
                      />
                      <label className="form-check-label">
                        Use OneSignal
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Notification Image (Optional)</label>
                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          accept="image/*"
                          onChange={handleImageSelect}
                          disabled={isUploadingImage}
                          id="imageUpload"
                        />
                        <label className="custom-file-label" htmlFor="imageUpload">
                          {isUploadingImage ? 'Uploading...' : 'Choose image file'}
                        </label>
                      </div>

                      {/* Upload Progress */}
                      {isUploadingImage && (
                        <div className="progress mt-2">
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${uploadProgress * 100}%` }}
                          >
                            {Math.round(uploadProgress * 100)}%
                          </div>
                        </div>
                      )}

                      {/* Image Preview */}
                      {notificationForm.image_url && (
                        <div className="mt-2">
                          <div className="d-flex align-items-center">
                            <img
                              src={notificationForm.image_url}
                              alt="Notification"
                              style={{
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                              }}
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger ml-2"
                              onClick={handleRemoveImage}
                            >
                              <i className="fa fa-times mr-1"></i>
                              Remove
                            </button>
                          </div>
                        </div>
                      )}

                      <small className="form-text text-muted">
                        <strong>Required:</strong> Upload an image to include with your notification (Max 5MB, JPG/PNG)
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSendNotification}
                  disabled={isLoading || !notificationForm.title || !notificationForm.body}
                >
                  {isLoading ? (
                    <>
                      <i className="fa fa-spinner fa-spin mr-2"></i>
                      Sending...
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-paper-plane mr-2"></i>
                      Send Notification
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default GeoTagView;